import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Config from "../../Constants/Config";
import { useQboApi } from "./qboApi";

const REFRESH_MS = 5 * 60 * 1000;
const NONE = { total: 0, reconnect: 0, days: 0, setup: 0 };

/**
 * What in QuickBooks needs the merchant, for the badge in the app header:
 * { total, reconnect, days, setup } from POST /QuickBooks/attention.
 * Refreshed on every page change and every 5 minutes. Any failure (integration
 * not configured, network) reads as nothing to show; the header never errors.
 */
export function useQboAttention() {
  const { post, ready, merchantId } = useQboApi();
  const { pathname } = useLocation();
  const [summary, setSummary] = useState(NONE);
  const enabled = ready;

  useEffect(() => {
    if (!enabled) {
      setSummary(NONE);
      return undefined;
    }
    let live = true;
    const load = () =>
      post(Config.QBO_ATTENTION)
        .then((r) => live && setSummary({ ...NONE, ...(r?.status ? r.data : null) }))
        .catch(() => live && setSummary(NONE));
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, [enabled, post, pathname, merchantId]);

  return summary;
}

/** One line for the menu: every kind of item, most urgent first. */
export function describeQboAttention({ reconnect, days, setup }) {
  const parts = [];
  if (reconnect) parts.push(reconnect === 1 ? "Reconnect needed" : `${reconnect} companies to reconnect`);
  if (days) parts.push(`${days} day${days === 1 ? "" : "s"} to review`);
  if (setup) parts.push(`${setup} store${setup === 1 ? "" : "s"} to finish setting up`);
  return parts.join(" · ");
}
